import React from 'react';

export default function ChevronDownIcon() {
  return <path d="m6 9 6 6 6-6" />;
}
